<div class="col-md-6">
  <label class="form-label">Empregador</label>
  <select
    class="form-select"
    name="terminalEmpregador"
    [ngModel]="empregadorSelecionado"
    (ngModelChange)="empregadorSelecionadoChange.emit($event)">
    <option value="">Selecione</option>
    <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
  </select>
</div>

<div class="col-md-6">
  <label class="form-label">Nome do terminal</label>
  <input
    class="form-control"
    name="terminalNome"
    [(ngModel)]="terminal.nome"
    (ngModelChange)="emitirTerminal()"
    placeholder="Recepcao, RH, Portaria"
    required>
</div>

<div class="col-md-4">
  <label class="form-label">Codigo de ativacao</label>
  <input
    class="form-control"
    name="terminalCodigo"
    [(ngModel)]="terminal.codigoServidor"
    (ngModelChange)="emitirTerminal()"
    placeholder="CASTELANDIA-RECEPCAO-01"
    required>
</div>

<div class="col-md-4">
  <label class="form-label">Tipo</label>
  <select
    class="form-select"
    name="terminalTipo"
    [(ngModel)]="terminal.tipo"
    (ngModelChange)="emitirTerminal()"
    required>
    <option value="DESKTOP">Desktop</option>
    <option value="TABLET">Tablet</option>
    <option value="TOTEM">Totem</option>
    <option value="IDFACE">Control ID iD Face</option>
  </select>
</div>

<div class="col-md-4">
  <label class="form-label">Localizacao</label>
  <input
    class="form-control"
    name="terminalLocalizacao"
    [(ngModel)]="terminal.localizacao"
    (ngModelChange)="emitirTerminal()"
    placeholder="Recepcao">
</div>

<div class="col-md-4" *ngIf="ehIdFace">
  <label class="form-label">IP do iD Face</label>
  <input
    class="form-control"
    name="terminalIpLeitor"
    [(ngModel)]="terminal.ipLeitor"
    (ngModelChange)="emitirTerminal()"
    placeholder="192.168.0.55:8089"
    title="Use IP:8089 se a tela do aparelho abrir nessa porta">
</div>

<div class="col-md-4" *ngIf="ehIdFace">
  <label class="form-label">Usuario do iD Face</label>
  <input
    class="form-control"
    name="terminalUsuarioLeitor"
    [(ngModel)]="terminal.usuarioLeitor"
    (ngModelChange)="emitirTerminal()"
    placeholder="admin">
</div>

<div class="col-md-4" *ngIf="ehIdFace">
  <label class="form-label">Senha do iD Face</label>
  <input
    class="form-control"
    type="password"
    name="terminalSenhaLeitor"
    [(ngModel)]="terminal.senhaLeitor"
    (ngModelChange)="emitirTerminal()"
    [placeholder]="terminal.temSenhaLeitor ? 'Senha ja gravada' : 'Senha'">
</div>

<div class="col-12" *ngIf="ehIdFace">
  <button
    type="button"
    class="btn btn-outline-primary"
    [disabled]="!terminal.id || importando"
    (click)="importarServidores.emit()">
    {{ importando ? 'Importando...' : 'Importar servidores no iD Face' }}
  </button>
  <button
    type="button"
    class="btn btn-outline-secondary ms-2"
    [disabled]="!terminal.id || importando || ligandoFoto"
    (click)="ligarFotoMonitor.emit()">
    {{ ligandoFoto ? 'Ligando foto...' : 'Ligar envio de foto da batida' }}
  </button>
  <div class="form-text">
    Envia matricula, nome e foto de referencia dos servidores ativos. Salve o terminal antes.
    IP com porta se o aparelho nao usar 80 (ex. <code>192.168.0.55:8089</code>). A senha so e reenviada se voce preencher o campo.
    No modo Online o menu do aparelho trava o envio de foto; use o botao de foto. O backend local precisa alcançar esse IP.
  </div>
</div>

<div class="col-md-3">
  <label class="form-label">Zoom da camera</label>
  <input
    class="form-control"
    type="number"
    min="1"
    max="3"
    step="0.1"
    name="terminalZoomCamera"
    [(ngModel)]="terminal.zoomCamera"
    (ngModelChange)="emitirTerminal()">
</div>

<div class="col-md-3">
  <label class="form-label">Area central (%)</label>
  <input
    class="form-control"
    type="number"
    min="45"
    max="100"
    step="1"
    name="terminalAreaLeituraCamera"
    [(ngModel)]="terminal.areaLeituraCameraPercentual"
    (ngModelChange)="emitirTerminal()">
</div>

<div class="col-md-3 d-flex align-items-center">
  <div class="form-check mt-4">
    <input
      class="form-check-input"
      type="checkbox"
      id="terminalAtivo"
      name="terminalAtivo"
      [(ngModel)]="terminal.ativo"
      (ngModelChange)="emitirTerminal()">
    <label class="form-check-label" for="terminalAtivo">Ativo</label>
  </div>
</div>

<div class="col-md-6">
  <label class="form-label">Departamentos autorizados</label>
  <select
    class="form-select"
    name="terminalDepartamentos"
    multiple
    size="4"
    [ngModel]="terminal.departamentoIds || []"
    (ngModelChange)="alterarDepartamentos($event)">
    <option *ngFor="let departamento of departamentos" [value]="departamento.id">{{ departamento.nome }}</option>
  </select>
  <div class="form-text">
    Vazio: qualquer servidor do empregador. Preenchido: so servidores desses departamentos batem neste relogio.
  </div>
</div>
